import { Component } from '@angular/core';

@Component({
  selector: 'app-enterprise-configuration-values',
  templateUrl: './enterprise-configuration-values.component.html',
  styleUrls: ['./enterprise-configuration-values.component.scss']
})
export class EnterpriseConfigurationValuesComponent {


}
